import { render, staticRenderFns } from "./MyTickets.vue?vue&type=template&id=324f73b2&scoped=true"
import script from "./MyTickets.vue?vue&type=script&lang=js"
export * from "./MyTickets.vue?vue&type=script&lang=js"
import style0 from "./MyTickets.vue?vue&type=style&index=0&id=324f73b2&prod&lang=less"
import style1 from "./MyTickets.vue?vue&type=style&index=1&id=324f73b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f73b2",
  null
  
)

export default component.exports